import { formatShortCzechDate } from "./formatUtils";
export var placeholderToken = function (placeholder) { return "{".concat(placeholder, "}"); };
var PLACEHOLDER_DESCRIPTION_ID_PREFIX = "ui-br-legaldeposits.libraries.messageTemplates.placeholders.description.";
export var findPlaceholderDescriptionId = function (placeholder, messages) {
    var id = "".concat(PLACEHOLDER_DESCRIPTION_ID_PREFIX).concat(placeholder);
    return Object.prototype.hasOwnProperty.call(messages, id) ? id : null;
};
export var findUsedEmptyPlaceholders = function (emptyPlaceholders, contents) {
    return emptyPlaceholders.filter(function (_a) {
        var placeholder = _a.placeholder;
        var token = placeholderToken(placeholder);
        return contents.some(function (content) { return content.includes(token); });
    });
};
export var findOnlyCustomVariant = function (template) {
    if (template.pluralUsed === false)
        return null;
    var singleSource = template.singleSource, pluralSource = template.pluralSource;
    if (!singleSource || !pluralSource || singleSource === pluralSource) {
        return null;
    }
    return singleSource === "LIBRARY" ? "SINGLE" : "PLURAL";
};
export var resolveVariantStatus = function (source, updatedAt) {
    if (!source)
        return null;
    if (source === "SYSTEM")
        return { kind: "SYSTEM" };
    return {
        kind: "LIBRARY",
        modifiedOn: updatedAt ? formatShortCzechDate(updatedAt) : null,
    };
};
export var splitByEmptyPlaceholders = function (text, placeholders) {
    if (placeholders.length === 0 || text === "") {
        return [{ start: 0, text: text, emptyPlaceholder: null }];
    }
    var tokens = new Map(placeholders.map(function (p) { return [placeholderToken(p), p]; }));
    var pattern = new RegExp("(".concat(Array.from(tokens.keys())
        .map(function (token) { return token.replace(/[{}]/g, "\\$&"); })
        .join("|"), ")"));
    var start = 0;
    return text
        .split(pattern)
        .filter(function (part) { return part !== ""; })
        .map(function (part) {
        var _a;
        var segment = {
            start: start,
            text: part,
            emptyPlaceholder: (_a = tokens.get(part)) !== null && _a !== void 0 ? _a : null,
        };
        start += part.length;
        return segment;
    });
};
